module.exports = __webpack_public_path__ + "static/img/barclay.ab0c4a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/barclay.png
// module id = +c3D
// module chunks = 0